import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { IMAGES } from "@/lib/images";

export default function TestimonialsSection({ content }) {
  const testimonials = content.testimonials || [];
  return (
    <section id="testimonials" className="relative py-28 lg:py-36 bg-[#151821]/40 grain" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono-tactical text-xs uppercase tracking-[0.25em] text-amber-500"
        >
          Endorsements
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-5 font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#F3F4F6] max-w-2xl"
          data-testid="testimonials-heading"
        >
          What facility leaders say after the first session.
        </motion.h2>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="bg-[#151821] border border-white/10 hover:border-amber-500/40 rounded-2xl p-8 flex flex-col transition-colors"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="text-amber-500" fill="currentColor" />
                ))}
              </div>
              <blockquote className="mt-5 text-sm sm:text-base text-[#F3F4F6]/90 leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img src={IMAGES.avatars[i % IMAGES.avatars.length]} alt="" className="w-10 h-10 rounded-full object-cover border border-amber-500/40" />
                <div>
                  <div className="text-sm font-semibold text-[#F3F4F6]">{t.name}</div>
                  <div className="font-mono-tactical text-[10px] tracking-[0.15em] text-[#6B7280]">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
